export function blurOpenSelectsInContainer(container, event) {
  if (!container || typeof container.querySelectorAll !== "function") {
    return;
  }

  // 检查滚动事件是否来自下拉框内部，如果是则不关闭
  if (event) {
    let target = event.target;
    // 向上遍历检查是否在 el-select-dropdown 内部
    while (target) {
      if (target.classList && target.classList.contains("el-select-dropdown")) {
        return; // 滚动来自下拉框内部，不关闭
      }
      target = target.parentNode;
    }
  }

  // 隐藏下拉框
  document.querySelectorAll(".el-select-dropdown").forEach(select => {
    select.style.display = "none";
  });

  const selectWrappers = container.querySelectorAll(".el-select");

  selectWrappers.forEach((selectWrap) => {
    // 去掉 focus 状态类和反转图标
    const input = selectWrap.querySelector(".el-input");
    if (input) {
      input.classList.remove("is-focus");
      // 触发 input 的 blur 事件
      const inputInner = input.querySelector(".el-input__inner");
      if (inputInner) {
        inputInner.blur();
      }
      const inputIcon = input.querySelector(".el-input__icon");
      if (inputIcon) {
        inputIcon.classList.remove("is-reverse");
      }
    }
  });
}

export default {
  install(Vue) {
    Vue.directive("close-select", {
      bind(el, binding) {
        el.__closeSelectDisabled__ = binding.value === false;
      },

      inserted(el, binding) {
        const run = (event) => {
          if (el.__closeSelectDisabled__) return;
          blurOpenSelectsInContainer(el, event);
        };

        el.__closeSelectHandler__ = run;

        // 使用 requestAnimationFrame 确保 DOM 完全渲染
        requestAnimationFrame(() => {
          // 查找所有可能的滚动容器
          const scrollContainers = [];

          // 方式1：查找 el-table 的滚动容器
          const bodyWrapper = el.querySelector(".el-table__body-wrapper");
          const headerWrapper = el.querySelector(".el-table__header-wrapper");

          if (bodyWrapper) {
            scrollContainers.push(bodyWrapper);
          }
          if (headerWrapper) {
            scrollContainers.push(headerWrapper);
          }

          // 方式2：查找具有 overflow 属性的子元素
          const allChildren = el.querySelectorAll("*");
          allChildren.forEach(child => {
            const style = window.getComputedStyle(child);
            if ((style.overflowX === "auto" || style.overflowX === "scroll" ||
              style.overflowY === "auto" || style.overflowY === "scroll") &&
              !scrollContainers.includes(child)) {
              scrollContainers.push(child);
            }
          });

          // 如果找到滚动容器，绑定到滚动容器；否则绑定到元素本身
          if (scrollContainers.length > 0) {
            el.__closeSelectScrollContainers__ = scrollContainers;
            scrollContainers.forEach(container => {
              container.addEventListener("scroll", run, { passive: true });
            });
          } else {
            el.addEventListener("scroll", run, { passive: true });
          }
        });
      },

      update(el, binding) {
        el.__closeSelectDisabled__ = binding.value === false;
      },

      unbind(el) {
        const run = el.__closeSelectHandler__;
        if (run) {
          if (el.__closeSelectScrollContainers__) {
            el.__closeSelectScrollContainers__.forEach(container => {
              container.removeEventListener("scroll", run);
            });
            delete el.__closeSelectScrollContainers__;
          } else {
            el.removeEventListener("scroll", run);
          }
          delete el.__closeSelectHandler__;
        }
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/units/directive/closeSelect.js